<div>
    <button (click)="btnClick()" title="{{buttonData.title}}"
        class="mat-focus-indicator mat-fab-bottom-right mat-fab mat-button-base mat-primary rounded-buttons"><img
            [src]="buttonData?.imageUrl" title="{{buttonData.title}}" class="h-30" alt="AddPlant"></button>
</div>